export default __webpack_public_path__ + "static/media/washing-machine-gray.a6806701.svg";